<div>
    <div class="drag-container">
        @for (option of dropdownOptions; track option.guid; let index = $index) {
            <app-select-option
                appTbDropContainer
                appTbDrag
                orientation="vertical"
                [dragData]="getDropdownDragData(option, index)"
                [data]="getDropdownDragData(option, index)"
                (droppedContainer)="drop($event)"
                [field]="field"
                [option]="option"
                [optionGroup]="getOptionGroup(option.guid!)"
                [isDefault]="option.guid === defaultOption?.guid"
                (delete)="delete(option.guid!)"
            ></app-select-option>
        }
    </div>
    <app-tb-button
        *transloco="let tSettings; read: 'status_configuration'"
        appearance="text"
        icon="add_circle_outline"
        (click)="add()"
        >{{ tSettings('add_status') }}</app-tb-button
    >
</div>
